import { render } from "./Home.vue?vue&type=template&id=3e8b57b2"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-logistics-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__